import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useGameCodeLaunch } from '@interlayer/js/app/components/main/Games/hooks/useGameLaunch';
import { useIsPageFullLoaded } from '@interlayer/js/components/system/Page/buzz/hooks/useIsPageFullLoaded';

export const LaunchGame = () => {
    const { gameCode } = useParams();
    const isPageFullLoaded = useIsPageFullLoaded();
    const gameLaunch = useGameCodeLaunch(gameCode);

    useEffect(() => {
        if (!isPageFullLoaded) {
            return;
        }

        gameLaunch();
    }, [gameLaunch, isPageFullLoaded]);

    return null;
};
